<template>
  <div class="RelationalDatabaseService">
    <div class="RelationalDatabaseService-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ this.$route.query.accountTypeName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.accountName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.databaseId }}</BreadcrumbItem>
        <BreadcrumbItem to="/monitor/relationalDatabaseServiceMonitor">{{
          $t("alarms.database.database")
        }}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <Row type="flex" justify="space-between" class="code-row-bg">
      <Col span="6">
        <Card style="height: 480px">
          <Row>
            <Row style="height: 240px">
              <Col
                span="24"
                style="
                  text-align: center;
                  font-size: 103px;
                  display: block;
                  margin-top: 8px;
                "
              >
                <img :src="protectEasyLogo" style="width: 83px" />
              </Col>
              <Col style="text-align: center; font-size: 18px">{{
                this.$route.query.databaseId
              }}</Col>
            </Row>

            <Row style="margin-bottom: 20px">
              <Col>{{ $t("alarms.common.hostDescription") }}</Col>
              <Col>---</Col>
            </Row>
            <!-- AWS -->
            <Row v-show="isAWS">
              <Col style="margin-bottom: 8px">{{
                $t("alarms.database.databaseConfiguration")
              }}</Col>
              <Row>
                <Col span="12">{{ $t("alarms.database.storage") }}:</Col>
                <Col span="10">{{ allocatedStorage }}GiB</Col>
              </Row>
              <Row>
                <Col span="12">{{ $t("alarms.database.storageType") }}:</Col>
                <Col span="10">{{ storageType }}</Col>
              </Row>
            </Row>
            <!-- 阿里云 -->
            <Row v-show="isALY">
              <Col style="margin-bottom: 8px">{{
                $t("alarms.database.databaseConfiguration")
              }}</Col>
              <Row>
                <Col span="12">{{ $t("alarms.database.engine") }}:</Col>
                <Col span="10">{{ engines }}</Col>
              </Row>
              <Row>
                <Col span="12">{{ $t("alarms.database.type") }}:</Col>
                <Col span="10">{{ databaseClass }}</Col>
              </Row>
            </Row>
            <!-- Azure -->
            <Row v-show="isAzure">
              <Col style="margin-bottom: 8px">{{
                $t("alarms.database.databaseConfiguration")
              }}</Col>
              <Row>
                <Col span="12">{{ $t("alarms.database.storage") }}:</Col>
                <Col span="10">{{ allocatedStorage }}GiB</Col>
              </Row>
              <Row>
                <Col span="12">{{ $t("alarms.database.storageType") }}:</Col>
                <Col span="10">{{ storageType }}</Col>
              </Row>
            </Row>
            <!-- gcp -->
            <Row v-show="isGCP">
              <Col style="margin-bottom: 8px">{{
                $t("alarms.database.databaseConfiguration")
              }}</Col>
              <Row>
                <Col span="12">{{ $t("alarms.database.engine") }}:</Col>
                <Col span="10">{{ engines }}</Col>
              </Row>
              <Row>
                <Col span="12">{{ $t("alarms.database.type") }}:</Col>
                <Col span="10">{{ databaseClass }}</Col>
              </Row>
            </Row>
            <!-- 腾讯云 -->
            <Row v-show="isTencent">
              <Col style="margin-bottom: 8px">{{
                $t("alarms.database.databaseConfiguration")
              }}</Col>
              <Row>
                <Col span="12">{{ $t("alarms.database.engine") }}:</Col>
                <Col span="10">{{ engines }}</Col>
              </Row>
              <Row>
                <Col span="12">{{ $t("alarms.database.type") }}:</Col>
                <Col span="10">{{ databaseClass }}</Col>
              </Row>
            </Row>
          </Row>
        </Card>
      </Col>
      <Col span="13">
        <Card style="height: 480px">
          <ul class="content">
            <li>
              <Row>
                <Col span="12">
                  <Col span="4">
                    <Button shape="circle" icon="ios-laptop"></Button>
                  </Col>
                  <Col span="20">
                    <Row>
                      <Col>{{ $t("alarms.database.databaseInformation") }}</Col>
                      <Row class="host">
                        <!-- AWS -->
                        <Col v-show="isAWS">
                          <ul>
                            <li>{{ $t("alarms.database.databaseId") }}：</li>
                            <li>{{ this.$route.query.databaseId }}</li>
                          </ul>
                        </Col>
                        <Col v-show="isAWS">
                          <ul>
                            <li>{{ $t("alarms.common.createdTime") }}：</li>
                            <li>{{ launchTime }}</li>
                          </ul>
                        </Col>

                        <!-- 阿里云 -->
                        <Col v-show="isALY">
                          <ul>
                            <li>{{ $t("alarms.database.databaseId") }}：</li>
                            <li>{{ this.$route.query.databaseId }}</li>
                          </ul>
                        </Col>
                        <Col v-show="isALY">
                          <ul>
                            <li>{{ $t("alarms.common.createdTime") }}：</li>
                            <li>{{ databaseCreationDate }}</li>
                          </ul>
                        </Col>

                        <!-- Azure -->
                        <Col v-show="isAzure">
                          <ul>
                            <li>{{ $t("alarms.database.databaseId") }}：</li>
                            <li>{{ this.$route.query.databaseId }}</li>
                          </ul>
                        </Col>
                        <!-- gcp -->
                        <Col v-show="isGCP">
                          <ul>
                            <li>{{ $t("alarms.database.databaseId") }}：</li>
                            <li>{{ this.$route.query.databaseId }}</li>
                          </ul>
                        </Col>
                        <Col v-show="isGCP">
                          <ul>
                            <li>{{ $t("alarms.common.createdTime") }}：</li>
                            <li>{{ databaseCreationDate }}</li>
                          </ul>
                        </Col>
                        <!-- 腾讯云 -->
                        <Col v-show="isTencent">
                          <ul>
                            <li>{{ $t("alarms.database.databaseId") }}：</li>
                            <li>{{ this.$route.query.databaseId }}</li>
                          </ul>
                        </Col>
                        <Col v-show="isTencent">
                          <ul>
                            <li>{{ $t("alarms.common.createdTime") }}：</li>
                            <li>{{ databaseCreationDate }}</li>
                          </ul>
                        </Col>
                      </Row>
                    </Row>
                  </Col>
                </Col>
                <Col span="12">
                  <Col span="4">
                    <Button shape="circle" icon="ios-pulse"></Button>
                  </Col>
                  <Col span="20">
                    <Row>
                      <Col>{{ $t("alarms.common.monitorMessage") }}</Col>
                      <Row class="host">
                        <Col>
                          <ul>
                            <li>{{ $t("alarms.common.monitorItems") }}：</li>
                            <li>
                              {{ monitoringNum }}{{ $t("alarms.common.count") }}
                            </li>
                          </ul>
                        </Col>
                        <Col>
                          <a
                            @click="monitorRDS"
                            v-hasPermission="[
                              'monitor:relationalDatabaseServiceDetail:overview'
                            ]"
                            >{{ $t("alarms.common.viewMonitoringOverview") }}</a
                          >
                        </Col>
                        <Col v-if="this.$route.query.accountTypeName == 'AWS'">
                          <a @click="handleViewForecastMonitoringOverview">{{
                            $t("alarms.common.viewForecastMonitoringOverview")
                          }}</a>
                        </Col>
                      </Row>
                    </Row>
                  </Col>
                </Col>
              </Row>
            </li>
            <li>
              <Row>
                <Col span="12">
                  <Col span="4">
                    <Button shape="circle" icon="ios-medkit-outline"></Button>
                  </Col>
                  <Col span="20">
                    <Row>
                      <Col>{{ $t("alarms.common.alertRule") }}</Col>
                      <Row class="host">
                        <Col>
                          <ul>
                            <li>{{ $t("alarms.common.alertRule") }}：</li>
                            <li>{{ priorityNum }}</li>
                          </ul>
                        </Col>
                        <Col>
                          <ul>
                            <li>{{ $t("alarms.common.untreated") }}：</li>
                            <li>{{ statusNum }}</li>
                          </ul>
                        </Col>
                        <Col>
                          <a
                            @click="alertRule"
                            v-hasPermission="[
                              'monitor:relationalDatabaseServiceDetail:alert_rule'
                            ]"
                            >{{ $t("alarms.common.viewAlarmRules") }}</a
                          >
                        </Col>
                      </Row>
                    </Row>
                  </Col>
                </Col>
              </Row>
            </li>
          </ul>
        </Card>
      </Col>
      <Col span="4" v-show="isAWS">
        <Card style="height: 480px">
          <Row>
            <Row style="margin-bottom: 10px">
              <Col>{{ $t("alarms.common.tags") }}</Col>
            </Row>
            <Row>
              <Col v-for="(item, index) in tagList" v-bind:key="index">
                <Tag color="default">{{ item.key }} : {{ item.value }}</Tag>
              </Col>
            </Row>
          </Row>
        </Card>
      </Col>
      <Col span="4" v-show="isALY">
        <Card style="height: 480px">
          <Row>
            <Row style="margin-bottom: 10px">
              <Col>{{ $t("alarms.common.tags") }}</Col>
            </Row>
            <Row>
              <Col v-for="(item, index) in aliRdsTag" v-bind:key="index">
                <Tag color="default">{{ item.key }} : {{ item.value }}</Tag>
              </Col>
            </Row>
          </Row>
        </Card>
      </Col>
      <Col span="4" v-show="isAzure">
        <Card style="height: 480px">
          <Row>
            <Row style="margin-bottom: 10px">
              <Col>{{ $t("alarms.common.tags") }}</Col>
            </Row>
          </Row>
        </Card>
      </Col>
      <Col span="4" v-show="isGCP">
        <Card style="height: 480px">
          <Row>
            <Row style="margin-bottom: 10px">
              <Col>{{ $t("alarms.common.tags") }}</Col>
            </Row>
            <Row>
              <Col v-for="(item, index) in tagList" v-bind:key="index">
                <Tag color="default">{{ item.key }} : {{ item.value }}</Tag>
              </Col>
            </Row>
          </Row>
        </Card>
      </Col>
      <Col span="4" v-show="isTencent">
        <Card style="height: 480px">
          <Row>
            <Row style="margin-bottom: 10px">
              <Col>{{ $t("alarms.common.tags") }}</Col>
            </Row>
            <Row>
              <Col v-for="(item, index) in tagList" v-bind:key="index">
                <Tag color="default">{{ item.key }} : {{ item.value }}</Tag>
              </Col>
            </Row>
          </Row>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import utils from "../../../utils/utils.js";
export default {
  name: "RelationalDatabaseService",
  data() {
    return {
      isAWS: false,
      isALY: false,
      isAzure: false,
      isGCP: false,
      isTencent: false,
      id: "",
      accountId: "",
      product: "",
      databaseId: "",
      region: "",
      engines: "",
      accountTypeName: "",
      accountName: "",
      allocatedStorage: "",
      storageType: "",
      monitoringRoleArn: "",
      dbiResourceId: "",
      databaseClass: "",
      dateBaseName: "",
      launchTime: "",
      priorityNum: "",
      statusNum: "",
      dbType: "",
      dbEngine: "",
      tagList: [],
      aliRdsTag: [],
      monitoringNum: "",
      databaseInstanceId: "",
      protectEasyLogo: require("../../../../static/images/rds.png"),
      databaseCreationDate: ""
    };
  },
  mounted() {
    if (this.$route.query.accountTypeName == "AWS") {
      this.isAWS = true;
      this.queryDatabasesById();
    } else if (this.$route.query.accountTypeName == "Aliyun") {
      this.isALY = true;
      this.queryDatabasesById();
    } else if (this.$route.query.accountTypeName == "Azure") {
      this.isAzure = true;
      this.queryDatabasesById();
    } else if (this.$route.query.accountTypeName == "GCP") {
      this.isGCP = true;
      this.queryDatabasesById();
    } else if (this.$route.query.accountTypeName == "Tencent Cloud") {
      this.isTencent = true;
      this.queryDatabasesById();
    }
  },
  methods: {
    init: function() {
      this.id = this.$route.query.id;
      this.accountId = this.$route.query.accountId;
      this.databaseId = this.$route.query.databaseId;
      this.region = this.$route.query.region;
      this.accountTypeName = this.$route.query.accountTypeName;
      this.accountName = this.$route.query.accountName;
      this.name = this.$route.query.name;
      this.engine = this.$route.query.engine;
    },
    // 通过databaseId查询实例
    queryDatabasesById: function() {
      var alertList = {
        accountId: this.$route.query.accountId,
        databaseId: this.$route.query.databaseId,
        region: this.$route.query.region,
        dbType: this.$route.query.dbType,
        dbEngine: this.$route.query.dbEngine
      };
      if (
        this.$route.query.accountTypeName == "Azure" &&
        this.$route.query.engine == "mysql"
      ) {
        alertList.monitorModule = 18;
      } else if (
        this.$route.query.accountTypeName == "Azure" &&
        this.$route.query.engine == "SQL Server"
      ) {
        alertList.monitorModule = 19;
      } else if (
        this.$route.query.accountTypeName == "AWS" ||
        this.$route.query.accountTypeName == "Aliyun" ||
        this.$route.query.accountTypeName == "GCP" ||
        this.$route.query.accountTypeName == "Tencent Cloud"
      ) {
        alertList.monitorModule = 1;
      }
      this.$api.rds.queryDatabasesById(alertList).then(res => {
        this.allocatedStorage = res.data.allocatedStorage;
        this.storageType = res.data.storageType;
        this.monitoringRoleArn = res.data.monitoringRoleArn;
        this.dbiResourceId = res.data.dbiResourceId;
        this.dateBaseName = res.data.dateBaseName;
        this.launchTime = utils.methods.formatDate(res.data.launchTime);
        this.priorityNum = res.data.priorityNum;
        this.statusNum = res.data.statusNum;
        this.monitoringNum = res.data.monitoringNum;
        this.tagList = res.data.rdsTag;
        this.engines = res.data.engine;
        this.databaseClass = res.data.databaseClass;
        this.databaseInstanceId = res.data.databaseInstanceId;
        this.databaseCreationDate = utils.methods.formatDate(
          res.data.databaseCreationDate
        );
        this.product = res.data.product;
        this.aliRdsTag = res.data.aliRdsTag;
      });
    },
    // 点击查看监控概览
    monitorRDS: function() {
      this.init();
      this.$router.push({
        path: "/monitor/RDS/",
        query: {
          id: this.id,
          accountId: this.accountId,
          databaseId: this.databaseId,
          region: this.region,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          name: this.name,
          engine: this.engine,
          product: this.product
        }
      });
    },
    // 点击查看报警规则
    alertRule: function() {
      this.init();
      this.$router.push({
        path: "/monitor/relationalDatabaseServiceWarning/",
        query: {
          id: this.id,
          accountId: this.accountId,
          databaseId: this.databaseId,
          region: this.region,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          name: this.name,
          engine: this.engine
        }
      });
    },
    // 查看预测监控概况
    handleViewForecastMonitoringOverview() {
      this.init();
      this.$router.push({
        path: "/monitor/RDSForecast/",
        query: {
          id: this.id,
          accountId: this.accountId,
          instanceId: this.databaseId,
          region: this.region,
          // privateIp: this.privateIp,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          name: this.name
        }
      });
    }
  }
};
</script>

<style scoped>
.RelationalDatabaseService-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}
.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
.host ul {
  list-style: none;
  overflow: hidden;
}
.host ul li {
  float: left;
}
.content > li {
  margin-bottom: 6px;
  border-bottom: 1px dashed #ccc;
  padding: 12px;
}
.content > li:last-child {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/rds/RelationalDatabaseServiceDetail.vue